import React, { useState, useEffect } from 'react'
import { ICallUsGraph } from './types'
import isChromatic from 'chromatic/isChromatic'
//MUI
import Typography from '@mui/material/Typography'
import RichText from '../RichText'
import Box from '@mui/material/Box'
import { useTheme } from '@mui/material/styles'

const CallUsGraph = ({ graphData, details }: ICallUsGraph) => {
  const widthAspect = 10 / graphData?.length

  const { breakpoints } = useTheme()
  const styles = {
    notCallHeader: {
      textAlign: 'center',
    },
    imageWrapper: {
      textAlign: 'center',
      padding: '20px 0',
      [breakpoints.down('sm')]: {
        '& > img': {
          width: '180px',
        },
      },
    },
    notCallDescription: {
      textAlign: 'center',
    },
    businessText: {
      padding: '20px 0 12px 0',
    },
    graphContainer: { display: 'flex' },
    nowBar: {
      width: '24px',
      height: '14px',
      borderRadius: '6px',
      backgroundColor: 'success.light',

      margin: '0 0 6px 0',
      display: 'flex',
      justifyContent: 'center',
    },
    nowText: {
      fontSize: '10px',
      fontWeight: 700,
    },
    barContainer: {
      padding: '0 7px 0 0',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-end',
    },
    barColumn: {
      backgroundColor: 'success.contrastText',
      width: `${widthAspect * 40}px`,
      [breakpoints.down('lg')]: {
        width: `${widthAspect * 40}px`,
      },
      [breakpoints.down('sm')]: {
        width: `${widthAspect * 19}px`,
      },
    },
    barTime: {
      padding: '10px 0 0 0',
      fontWeight: 300,
    },
    currentBarColumn: {
      backgroundColor: 'success.light',
    },
    currentBarTime: {
      fontWeight: 600,
    },
  }

  const [currentIndex, setCurrentIndex] = useState(-1)

  useEffect(() => {
    const currentTime = isChromatic() ? 12 : new Date().getHours()

    graphData?.forEach((item, index) => {
      if (parseInt(item.time) === currentTime) {
        setCurrentIndex(index)
      }
    })
  }, [])

  return (
    <Box>
      {currentIndex === -1 ? (
        <Box>
          <Typography variant={'h5'} sx={styles.notCallHeader}>
            Øv, det er uden for vores åbningstid
          </Typography>
          <Box sx={styles.imageWrapper}>
            <img src={'/not_call_us_illustration.svg'} alt={'NotCallUs'} />
          </Box>
          <Typography variant={'body1'} sx={styles.notCallDescription}>
            Vores åbningstider er: {graphData[0].time} til {graphData[graphData.length - 1].time}
            <br></br> Du kan også vælge at skrive til os
          </Typography>
        </Box>
      ) : (
        <Box>
          {details?.raw && <RichText raw={details?.raw} references={[]} />}
          <Typography variant={'subtitle1'} sx={styles.businessText}>
            Gennemsnitlig travlhed på telefonen
          </Typography>
          <Box sx={styles.graphContainer}>
            {graphData.map((item, index) => {
              return (
                <Box key={index} sx={styles.barContainer}>
                  {index == currentIndex && (
                    <Box sx={styles.nowBar}>
                      <Typography sx={styles.nowText}>Nu</Typography>
                    </Box>
                  )}
                  <Box
                    sx={index == currentIndex ? [styles.barColumn, styles.currentBarColumn] : styles.barColumn}
                    style={{
                      height: parseInt(item.value, 10) * 1.2,
                    }}
                  ></Box>
                  <Typography
                    variant="caption"
                    sx={index == currentIndex ? [styles.barTime, styles.currentBarTime] : styles.barTime}
                  >
                    {item.time}
                  </Typography>
                </Box>
              )
            })}
          </Box>
        </Box>
      )}
    </Box>
  )
}

export default CallUsGraph
